import * as Yup from 'yup';

export const exampleSchema = Yup.object().shape({
    name: Yup.string()
        .required('Enter a name')
        .matches(/^[\w\s]+$/, 'The name can only contain letters, numbers, and spaces'),
});
